module.exports = __webpack_public_path__ + "img/tablet.9f8791e2.svg";